import { assignInput, BaseModel } from '../../base.model';

export class ManpowerAttachment extends BaseModel {
  DateModified: any = '';
  Description: any = '';
  FileID: any = '';
  FileName: any = '';
  ManPowerAttachmentID: any = '';
  ManPowerReqID: any = '';
  ModifiedUserID: any = '';
  ModifiedUserName: any = '';
  PlantID: any = '';
  Type: any = '';
  TypeName: any = '';
  bActive: any = '';
  File: any = null;

  constructor(o: any = null) {
    super(o);
    // WI 35894: re-apply o after this class's field initializers (see assignInput in base.model.ts).
    assignInput(this, o);
  }
}
